<template>
  <div class="admin-table-block">
    <div class="table-toolbar">
      <div class="d-flex align-items-center gap-2 flex-wrap">
        <div class="table-search">
          <i class="bi bi-search"></i>
          <input v-model.trim="filterField" type="search" placeholder="Buscar módulo por nombre..." @input="filtro" />
          <button v-if="filterField" type="button" @click="filterField=''; filtro()" aria-label="Limpiar"><i class="bi bi-x-lg"></i></button>
        </div>
        <div class="page-size-control"><span>Mostrar</span><select v-model.number="itemsPerPage" @change="onPageSizeChange" class="form-select form-select-sm"><option v-for="size in pageSizeOptions" :key="size" :value="size">{{ size }}</option></select><span>registros</span></div>
      </div>
      <span class="toolbar-count">{{ totalRows }} resultado(s)</span>
    </div>

    <div class="table-responsive admin-table-wrap">
      <table class="table admin-table align-middle">
        <thead><tr>
          <th class="sortable-th id-col" @click="sortBy('idModulo')">ID <i class="bi" :class="sortIcon('idModulo')"></i></th>
          <th class="sortable-th" @click="sortBy('nomModulo')">Módulo <i class="bi" :class="sortIcon('nomModulo')"></i></th>
          <th class="sortable-th" @click="sortBy('audfechaCreacion')">Creación <i class="bi" :class="sortIcon('audfechaCreacion')"></i></th>
          <th class="sortable-th" @click="sortBy('audfechaActualizacion')">Actualización <i class="bi" :class="sortIcon('audfechaActualizacion')"></i></th>
          <th class="actions-col">Acciones</th>
        </tr></thead>
        <tbody>
          <tr v-if="loading"><td colspan="5"><div class="table-state"><span class="spinner-border spinner-border-sm"></span><span>Filtrando módulos...</span></div></td></tr>
          <tr v-else-if="!paginatedLista.length"><td colspan="5"><div class="table-state"><i class="bi bi-inbox"></i><span>No hay módulos para mostrar.</span></div></td></tr>
          <tr v-else v-for="lista in paginatedLista" :key="lista.idModulo">
            <td class="id-cell">{{ lista.idModulo }}</td>
            <td><div class="module-cell"><span class="row-icon"><i :class="lista.nomIcono || 'bi bi-grid'"></i></span><strong>{{ lista.nomModulo }}</strong></div></td>
            <td><span class="audit-text">{{ lista.audfechaCreacion || '-' }}</span></td>
            <td><span class="audit-text">{{ lista.audfechaActualizacion || '-' }}</span></td>
            <td><div class="row-actions">
              <button type="button" class="action-btn edit" title="Editar módulo" @click="openEditModal(lista.idModulo, lista.nomModulo, lista.nomIcono, lista.idIcono)"><i class="bi bi-pencil-square"></i></button>
              <button type="button" class="action-btn delete" title="Eliminar módulo" @click="eliminarModulo(lista)"><i class="bi bi-trash3"></i></button>
            </div></td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="table-bottom justify-content-end">
      <div class="pagination-compact"><button @click="currentPage=1" :disabled="currentPage===1"><i class="bi bi-chevron-double-left"></i></button><button @click="currentPage--" :disabled="currentPage===1"><i class="bi bi-chevron-left"></i></button><span>Página {{ currentPage }} de {{ totalPages || 1 }}</span><button @click="currentPage++" :disabled="currentPage>=totalPages"><i class="bi bi-chevron-right"></i></button><button @click="currentPage=totalPages" :disabled="currentPage>=totalPages"><i class="bi bi-chevron-double-right"></i></button></div>
    </div>

    <b-modal ref="editModal" centered title="Editar módulo" hide-footer hide-close-button dialog-class="modal-md-custom">
      <div class="edit-modal-content">
        <label class="modal-field-title">Selecciona un icono</label>
        <div class="modal-icon-picker"><button v-for="icon in icons" :key="icon.nomIcono" type="button" @click="selectIcon(icon.nomIcono, icon.idIcono)" :class="{selected:icon.nomIcono===selectedIcon}"><i :class="icon.nomIcono"></i></button></div>
        <div class="mb-3"><label class="form-label fw-semibold">Nombre del módulo</label><input v-model.trim="editedIconName" type="text" class="form-control" /></div>
        <div class="modal-actions"><b-button variant="light" @click="closeEditModal">Cancelar</b-button><b-button variant="primary" @click="saveChanges"><i class="bi bi-check2"></i> Guardar cambios</b-button></div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import tableUx from "@/mixins/tableUx";
import Swal from "sweetalert";
import { mapGetters, mapActions } from "vuex";
export default {
  mixins: [tableUx],
  name: "PowerbyTablaModulo",

  data() {
    return {
      currentPage: 1,
      itemsPerPage: 5,
      loading: false,
      filterField: "",
      selectedIcon: "ninguno",
      icons: [],
      idIcono: "",
      editedIconName: ""
    };
  },

  mounted() {
    this.idUsuario = localStorage.getItem("userId");
    this.axios.get(`BIClientes/ListadoIconos`).then((r) => {
      console.log(r.data);
      this.icons = r.data;
    });
  },

  computed: {

    ...mapGetters('acciones', ['ListaModulos']),


    filteredList() {
      const filtro = (this.filterField || '').toLowerCase().trim();
      if (!filtro) return this.ListaModulos || [];

      return (this.ListaModulos || []).filter(item =>
        String(item.nomModulo).toLowerCase().includes(filtro)
      );
    },

    totalRows() { return this.filteredList.length; },

    totalPages() {
      return Math.ceil(this.filteredList.length / this.itemsPerPage);
    },


    startIndex() {
      return (this.currentPage - 1) * this.itemsPerPage;
    },


    paginatedLista() {

      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.sortedRows(this.filteredList).slice(start, start + this.itemsPerPage);
    },


  },

  created() {
  },

  methods: {
    ...mapActions('acciones', ['ListarModulo']),

    async eliminarModulo(modulo) {
      const confirmacion = await this.$swal.fire({
        icon: "warning",
        title: "¿Eliminar módulo?",
        text: `Se eliminará ${modulo.nomModulo} únicamente si no tiene categorías asociadas.`,
        showCancelButton: true,
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#dc3545",
      });
      if (!confirmacion.isConfirmed) return;
      try {
        const response = await this.axios.delete(`BIClientes/EliminarModulo?idModulo=${modulo.idModulo}`);
        const data = response.data || {};
        const eliminado = data === true || data.eliminado === true || data.success === true;
        if (!eliminado) throw new Error(data.mensaje || data.message || "El módulo tiene categorías asociadas y no puede eliminarse.");
        await this.ListarModulo();
        this.$swal.fire({ icon: "success", title: "Módulo eliminado", text: data.mensaje || "El módulo fue eliminado correctamente." });
      } catch (error) {
        const message = error.response?.data?.mensaje || error.response?.data?.message || error.message || "No se pudo eliminar el módulo.";
        this.$swal.fire({ icon: "info", title: "No se puede eliminar", text: message });
      }
    },
    openEditModal(idModulo, nombre, Icono, idIcono) {
      console.log(Icono, nombre, idModulo);
      this.idModulo = idModulo;
      this.editedIconName = nombre;
      this.selectedIcon = Icono;
      this.idIcono = idIcono;
      this.$refs.editModal.show();
    },

    closeEditModal() {
      this.idModulo = "";
      this.editedIconName = "";
      this.idIcono = "";

      this.$refs.editModal.hide();
    },
    saveChanges() {
      // Aquí puedes guardar el nombre editado y realizar otras operaciones necesarias
      // Luego, cierra el modal
      const from = {
        idUsuario: this.idUsuario,
        idIcono: this.idIcono,
        idModulo: this.idModulo,
        nomModulo: this.editedIconName,
      };

      console.log(from);
      this.axios.put(`BIClientes/ModificarModulo`, from).then((r) => {
        console.log(r.data);

        this.ListarModulo();
        Swal(`Se realizo los cambios`, "", "success");
        this.selectedIcon = "";
      });
      this.closeEditModal();
    },
    changePage(page) {
      this.currentPage = page;
    },

    selectIcon(iconClass, id) {
      this.selectedIcon = iconClass;
      this.idIcono = id;
    },
    filtro() {
      this.loading = true;
      setTimeout(() => {
        this.currentPage = 1;
        this.loading = false;
      }, 900);

    },
  },
};
</script>

<style scoped>
.admin-table-block{padding:.8rem}.table-toolbar{display:flex;align-items:center;justify-content:space-between;gap:.75rem;margin-bottom:.65rem}.table-search{width:min(100%,380px);min-height:42px;display:flex;align-items:center;gap:.55rem;padding:0 .75rem;border:1px solid var(--qhatu-border);border-radius:10px;background:#fff}.table-search>i{color:#8294a8}.table-search input{flex:1;min-width:0;border:0;outline:0;background:transparent;font-size:.82rem}.table-search button{width:30px;height:30px;border:0;border-radius:8px;background:#eef3f8;color:#6b7e92}.toolbar-count{color:var(--qhatu-muted);font-size:.76rem}.admin-table-wrap{border:1px solid var(--qhatu-border);border-radius:12px;overflow:auto}.admin-table{min-width:780px;margin:0}.admin-table thead th{padding:.58rem .7rem;background:#eef5f9;color:#385069;border:0;border-bottom:1px solid var(--qhatu-border);font-size:.7rem;text-transform:uppercase;letter-spacing:.025em}.admin-table tbody td{padding:.5rem .7rem;border-color:#edf1f5;font-size:.75rem}.id-col,.id-cell{width:70px;text-align:center}.actions-col{width:120px;text-align:center}.module-cell{display:flex;align-items:center;gap:.55rem}.module-cell strong{font-size:.78rem;color:#263c53}.row-icon{width:30px;height:30px;display:grid;place-items:center;border-radius:8px;background:var(--qhatu-primary-soft);color:var(--qhatu-primary)}.audit-text{color:#61758a;font-size:.7rem}.row-actions{display:flex;justify-content:center;gap:.35rem}.action-btn{width:34px;height:34px;border:0;border-radius:9px;display:grid;place-items:center;background:#f1f5f9;color:#63778c}.action-btn.edit{background:#fff4d6;color:#b97900}.action-btn.active{color:#07845f}.action-btn.inactive{color:#c44b55}.action-btn.delete{background:#fff0f1;color:#d93645}.table-state{min-height:115px;display:flex;align-items:center;justify-content:center;gap:.55rem;color:var(--qhatu-muted)}.table-bottom{display:flex;align-items:center;justify-content:space-between;gap:.75rem;flex-wrap:wrap;padding-top:.65rem}.page-size-control{display:flex;align-items:center;gap:.4rem;color:var(--qhatu-muted);font-size:.75rem}.page-size-control select{width:70px;min-height:34px}.pagination-compact{display:flex;align-items:center;gap:.3rem}.pagination-compact button{width:34px;height:34px;border:1px solid var(--qhatu-border);border-radius:8px;background:#fff;color:var(--qhatu-primary)}.pagination-compact button:disabled{opacity:.4}.pagination-compact span{padding:0 .35rem;color:#516579;font-size:.75rem}.modal-field-title{display:block;margin-bottom:.5rem;font-weight:700}.modal-icon-picker{display:grid;grid-template-columns:repeat(8,1fr);gap:.4rem;max-height:160px;overflow:auto;margin-bottom:1rem}.modal-icon-picker button{height:38px;border:1px solid var(--qhatu-border);border-radius:8px;background:#fff}.modal-icon-picker button.selected{border-color:var(--qhatu-primary);background:var(--qhatu-primary-soft);color:var(--qhatu-primary)}.modal-actions{display:flex;justify-content:flex-end;gap:.5rem}@media(max-width:575.98px){.admin-table-block{padding:.6rem}.table-toolbar{align-items:stretch;flex-direction:column}.table-search{width:100%}.toolbar-count{align-self:flex-end}.table-bottom{align-items:stretch;flex-direction:column}.pagination-compact{justify-content:center}.modal-icon-picker{grid-template-columns:repeat(6,1fr)}}
</style>